import axios from "axios";
import { BASE_URL } from "../constants/mainAPI";
import { API_DADATA_KEY, BASE_DADATA_URL } from "../constants/fiasAPI";

const $api = axios.create({
    baseURL: BASE_URL,
});

$api.interceptors.request.use(
    config => {
        config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

const $apiDadata = axios.create({
    baseURL: BASE_DADATA_URL,
});

$apiDadata.interceptors.request.use(
    config => {
        config.headers.Authorization = `Token ${API_DADATA_KEY}`;
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);

export { $api, $apiDadata };
